import { type FunctionComponent, useEffect, useState } from 'react'

import { useFeatureValue } from '@growthbook/growthbook-react'

import { useRecentlyViewedBannerQuery } from '../../../generated/frontend'
import { Consent, hasCookieConsent } from '../../utils/hasCookieConsent'
import { RecentlyViewedTextList } from './components/RecentlyViewedTextList/RecentlyViewedTextList'

const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window?.innerWidth <= breakpoint : false
  )

  useEffect(() => {
    const handleResize = () => setIsMobile(window?.innerWidth <= breakpoint)

    window?.addEventListener('resize', handleResize)
    return () => window?.removeEventListener('resize', handleResize)
  }, [breakpoint])

  return isMobile
}

const BannerExperiment: FunctionComponent = () => {
  const showRecentlyViewed = useFeatureValue(
    'dsp-029-sitewide-pick-up-where-you-left-off-banner',
    false
  )
  return showRecentlyViewed ? <RecentlyViewed /> : null
}

export const RecentlyViewed = () => {
  const { data, loading, error } = useRecentlyViewedBannerQuery()

  if (loading || error || !data) {
    return null
  }

  const recentlyViewedItems = data?.signupCompletePage?.recentlyViewed?.content || []
  if (recentlyViewedItems.length === 0) {
    return null
  }
  return <RecentlyViewedTextList items={recentlyViewedItems} />
}

export const RecentlyViewedBanner = () => {
  const [cookieConsent, setHasCookieConsent] = useState(false)
  const isMobile = useIsMobile()

  useEffect(() => {
    const consent = hasCookieConsent(Consent.FunctionalAndPerformance)
    setHasCookieConsent(consent)
  }, [])

  if (!cookieConsent || isMobile) {
    return null
  }

  return <BannerExperiment />
}
